import {  Component, inject } from '@angular/core';
import { UserdataService } from '../../../../service/userdata.service';
import { Router } from '@angular/router';
import { SnackService } from '../../../../service/snack.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl } from '@angular/forms';
import { AiService } from '../../../../service/ai.service';
import { TrackService } from '../../../../service/track.service';

@Component({
  selector: 'app-rename-stream',
  standalone: false,
  templateUrl: './rename-stream.component.html',
  styleUrl: './rename-stream.component.scss'
})
export class RenameStreamComponent {
  readonly dialogRef = inject(MatDialogRef<RenameStreamComponent>);
  trackService = inject(TrackService);
  aiService = inject(AiService);

  name: FormControl = this.fb.control("My Business Model Canvas " + new Date().toLocaleString());
  showLoading: boolean = false;
  constructor(
    private userData: UserdataService,
    private router: Router,
    private snack: SnackService,
    private fb: FormBuilder
  ) { }


  async startTrack() {

    let projectId = await this.userData.getDefaultProjectId();

    if (!projectId) {
      this.snack.error(
        { error: { msg: { headline: "No Project found", message: "Please contact the support team. There is no project in your accouunt." } } }
      );
      return;
    }
    this.showLoading = true;
    let result = await this.trackService.startTrack('Clu-4-HBY', 'J1S-8At2nL', 'MMUT2vQla', projectId, this.name.value);
    this.showLoading = false;
    if (result === false) return;

    await this.trackService.updateTrackName(result, this.name.value)
    this.aiService.resetChat();
    this.router.navigate(['new-track-run', 'Clu-4-HBY'], {
      queryParams: {
        streamId: 'J1S-8At2nL',
        stepId: 'MMUT2vQla',
        roundId: result
      }
    });

    this.dialogRef.close('newTrack');
  }
  async cancel() {
    this.router.navigate(['home','user']);
    this.dialogRef.close('close');
  }
}
